import { AfterContentChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, } from '@angular/forms';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { TabPosition, TabStripTabComponent } from '@progress/kendo-angular-layout';
import { Observable } from 'rxjs';
import { GridColumnMap } from '~/front-models/gridColumnMap';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { UserSummary } from '~/models/administration/user';
import { Chart } from '~/models/chart/chart';
import { CustomFieldSummary } from '~/models/modules/customField';
import { GridFieldSummary } from '~/models/modules/gridField';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { LocationSummary } from '~/models/modules/location';
import { StartEndDateChartResponseModel } from '~/models/modules/startEndDateChartResponseModel';
import { AccountsService } from '~/services/administration.ts/accounts';
import { AddressesService } from '~/services/modules/stocks/addresses';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { StockItemsService } from '~/services/modules/stocks/items';
import { LocationTypesService } from '~/services/modules/stocks/location-types';
import { LocationsService } from '~/services/modules/stocks/locations';
import { SecurityService } from '~/services/security.service';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { NoteComponent } from '~/shared/components/note/note.component';
import { LocationType } from './../../../../../models/modules/locationType';
import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';
import { FacilityService } from '~/services/modules/stocks/facility';
import { Facility } from './../../../../../models/modules/facility';
import { Floor } from '~/models/modules/floor';
import { BuildingService } from '~/services/modules/stocks/building';
import { Building } from '~/models/modules/building';
import { FloorService } from '~/services/modules/stocks/floor';
import { GDataService } from '~/services/GDataService';
import { Address } from 'cluster';
import { FormatTypes } from '~/shared/enums/FormatTypes';
import { MultiSiteService } from '~/services/modules/common/multi-site.service';
import { SitesEnum } from '~/shared/enums/sites.enum';


@Component({
    selector: 'app-stocks-locations-upsert',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StocksLocationsUpsertComponent extends MultiSiteAwareComponent
  implements OnInit, OnDestroy, AfterContentChecked, AfterViewInit {
  _deactivatedFormTabsForm: boolean = false
  _deactivatedFormTabsGridData: Array<any> = [];

  _kendoTabStripPosition: TabPosition = 'left';
  _innerWidth: any;
  _hiddenWindow: any;
  _maximized: any;
  _accountColumnsMap: GridColumnMap[] = [];
  _imageColumnsMap: GridColumnMap[] = [];
  _selectedAccount = new FormControl();
  _theme: string;
  _form: FormGroup;
  _addressForm: FormGroup;
  _active: boolean;
  _isAutoGeneratingNumber: boolean;
  _locationTypes: any[];
  _Facility: any[];
  _locationTypesFiltered: any[];
  _FacilityFiltered: any[];
  _addresses: any[];
  _addressesFiltered: any[];
  _locations: any[];
  _locationsFiltered: any[];
  _floorFiltered: any[];
  _getListOfFloor: Floor[];


  _currentType: string;
  _invalidForm: boolean;
  _model: LocationSummary;
  _locationsCode = new FormControl();
  _pageState: PageState;
  _showCirclesForm: boolean;
  _tooltipVisibilityUpsert: boolean = true;
  _tooltipVisibilityForm: boolean = true;
  _isCustomfieldsFormValue: boolean = false;
  _isAddTabFormValue: boolean = false;
  _isRenameFormValue: boolean = false;
  _selectedTabId: number;
  _editFormActive: boolean;
  _currentUser: UserSummary;
  _customFields: CustomFieldSummary[][] = [];
  _page = 'locations';
  _permissionScope = 'locations';
  _customTabs: any;
  _customFieldsValue: any = [];
  _customValidation: any[] = [];
  _additionalErrors: any[] = [];
  _gridFieldText: GridFieldTextSummary[];
  _language: string = 'en';
  _isRenameLabel: boolean = false;
  _selectedLabelObjectCode: any;
  _isRenameCustomFormValue: boolean = false;
  _selectedLabelId: number;
  _customFieldsDictionary: { [key: string]: string } = {};
  _selectedAccountIds: any[] = [];
  _systemFields: Array<any> = [];
  _editedSystemFields: Array<any> = [];
  _gridFieldAuth: GridFieldAuthorization[];
  _isMandatory: boolean = false;
  _requiredFields: Array<any> = [];
  _requiredFieldNames: Array<any> = [];
  _isEditForms: boolean = false;

  _showLocationsGrid: boolean = false;
  _showFacilityGrid: boolean = false;
  _showBuildingGrid: boolean = false;
  _showFloorGrid: boolean = false;
  _showAddressGrid: boolean = false;

  _locationsGridColumns: GridFieldSummary[];
  _locationsFacilityColumns: GridFieldSummary[];
  _BuildingColumns: GridFieldSummary[];
  _FloorColumns: GridFieldSummary[];
  _AddressesColumns: GridFieldSummary[];

  _selectedLocationTypes: LocationType[] = [];
  _selectedFacilityTypes: Facility[] = [];
  _selectedbuilding: Building[] = [];
  _selectedFloor: Floor[] = [];
  _selectedaddresses: Address[] = [];

  getlistofBuilding: any[] = [];
  bilidingFilter: any[];
  reloadlist: any;

  costPriceFormatType: FormatTypes = FormatTypes.CostandPriceFormat;
  quantityFormatType: FormatTypes = FormatTypes.QuantityFormat;

  _popupSaveModel: any;

  //#region custom Fields Fix
  copyModelId: number;
  _customRequiredFields: Array<any> = [];
  //#endregion
  _selectedCallback = (args: { dataItem: any }) => args.dataItem;

  @ViewChild('kendo_combo_vendors') kendoComboVendors: ComboBoxComponent;
  @ViewChild('kendo_combo_items') kendoComboItems: ComboBoxComponent;

  public _donutChartSmall: any[] = [
    {
      data: [
        {
          category: 'Site 1',
          value: 120,
          color: '#fff6d9',
          colorLabel: '#ae8d2a',
          font: '10px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'Site 2',
          value: 90,
          color: '#f2e2b1',
          colorLabel: '#ae8d2a',
          font: '10px -apple-system, BlinkMacSystemFont',
        },
      ],
      sum: 210,
      title: 'DC Health',
    },
    {
      data: [
        {
          category: 'Site 1',
          value: 30,
          color: '#e7e0fc',
          colorLabel: '#321982',
          font: '10px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'Site 2',
          value: 40,
          color: '#d1c7f0',
          colorLabel: '#321982',
          font: '10px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'Site 3',
          value: 120,
          color: '#b3a5e3',
          colorLabel: '#321982',
          font: '10px -apple-system, BlinkMacSystemFont',
        },
      ],
      sum: 180,
      title: 'Safe Workplace',
    },
    {
      data: [
        {
          category: 'Site 1',
          value: 30,
          color: '#e5fadd',
          colorLabel: '#458032',
          font: '10px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'Site 2',
          value: 120,
          color: '#abd59d',
          colorLabel: '#458032',
          font: '10px -apple-system, BlinkMacSystemFont',
        },
      ],
      sum: 150,
      title: 'District Logistics Center',
    },
  ];

  public _donutChartLarge: any[] = [
    {
      data: [
        {
          category: 'Site 1',
          value: 30,
          color: '#e5fadd',
          colorLabel: '#458032',
          font: '15px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'Site 2',
          value: 120,
          color: '#abd59d',
          colorLabel: '#458032',
          font: '15px -apple-system, BlinkMacSystemFont',
        },
      ],
      sum: 150,
      title: 'District Logistics Center',
    },
    {
      data: [
        {
          category: 'Site 1',
          value: 30,
          color: '#e7e0fc',
          colorLabel: '#321982',
          font: '15px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'Site 2',
          value: 40,
          color: '#d1c7f0',
          colorLabel: '#321982',
          font: '15px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'Site 3',
          value: 120,
          color: '#b3a5e3',
          colorLabel: '#321982',
          font: '15px -apple-system, BlinkMacSystemFont',
        },
      ],
      sum: 180,
      title: 'Safe Workplace',
    },
    {
      data: [
        {
          category: 'Site 1',
          value: 120,
          color: '#fff6d9',
          colorLabel: '#ae8d2a',
          font: '15px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'Site 2',
          value: 90,
          color: '#f2e2b1',
          colorLabel: '#ae8d2a',
          font: '15px -apple-system, BlinkMacSystemFont',
        },
      ],
      sum: 210,
      title: 'DC Health',
    },
  ];
  okCloseSubscription: any = null;
  _deactivatedFieldsForm: boolean = false;
  _deactivatedFieldsGridData: any[] = [];
  _NOSActive: boolean = true;
  _NOCActive: boolean = false;
  NumberofstockPerDate: any;
  NumberOfCatPerDate: any;
  _custominvalidForm: boolean;
  _invalidSubmit: boolean;

  reactivate: boolean = false;
  reactivateItem: any;

  PalletInfoSystemFields: Array<any> = [
    { title: 'LocPalletNbr' },
    { title: 'LocHomeLoc' },
    { title: 'LocCurrentLoc' },
  ];
  VehicleInfoSystemFields: Array<any> = [
    { title: 'LocTruckMake' },
    { title: 'LocTruckModel' },
    { title: 'LocTruckColor' },
    { title: 'LocTruckVin' },
    { title: 'LocTruckLicensePlate' },
    { title: 'LocHomeLoc' },
    { title: 'LocCurrentLoc' },
  ];

  _index: number;

  _userNewDataTabs: Array<any> = [];
  _dataTabs: Array<any> = [];
  _dataTabsSelected: Array<any> = [];
  _orderingTabsForm: boolean = false;

  stockItemLocationChartDetail: StartEndDateChartResponseModel;
  stockItemLocationChart: Chart;
  stockItemLocationSecondChart: Chart;

  _stockItemGridColumns: GridFieldSummary[];

  openStockItemLocationForm: boolean = false;
  isStockItemNumberGridExpanded: boolean = true;
  isStockItemNumberChartExpanded: boolean = true;

  @ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;
  @ViewChild('kendo_BarcodeGen_Location_ID')
  kendoBarcodeGenLocationID: ElementRef;
  @ViewChild('Kendo_Combobox_Account') kendoComboboxAccount: ComboBoxComponent;
  @ViewChild('Kendo_Combobox_Site') KendoComboboxSite: ComboBoxComponent;
  @ViewChild('Kendo_Combobox_Location_Type') KendoComboboxLocationType: ComboBoxComponent;
  @ViewChild('GeneralLocationInfoTab') GeneralLocationInfoTab: TabStripTabComponent;
  @ViewChild('kendo_Input_Location_Description')
  kendoInputLocationDescription: ElementRef;
  @ViewChild('textarea_address') addressTextarea: ElementRef;
  @ViewChild('kendo_combo_addresses') kendoComboAddresses: ComboBoxComponent;
  @ViewChild('mainWindow') kendoMainWindow: ElementRef;
  @ViewChild('note') note: NoteComponent;
  @ViewChild('Kendo_Combobox_Facility') KendoComboboxFacility: ComboBoxComponent;


  _isDialiog: boolean = false;
  _dialogComponentName: string;
  _dialogModel: any;

  long: number;
  lat: number;
  siteId: number = 0;
  // #region Enterprise Data
  _addClassActive: boolean = false;
  _selectedAccounts: any[] = [];
  _tabEnabled: boolean = true;
  // #endregion
  //#region Multi Site Variables

  //#endregion

  zoom = 12;
  center: google.maps.LatLngLiteral;
  options: google.maps.MapOptions = {
    mapTypeId: 'hybrid',
    zoomControl: false,
    scrollwheel: false,
    disableDoubleClickZoom: true,
    maxZoom: 15,
    minZoom: 8,
  };

  markers: any;

  //#region  CTOR
  constructor(private _accountsService: AccountsService,
    private _locationTypesService: LocationTypesService,
    private _locationsService: LocationsService,
    private _fb: FormBuilder,
    private _themeManager: ThemeManagerService,
    private _layoutManager: LayoutManagerService,
    private _layoutComponent: LayoutComponent,
    private _addressesService: AddressesService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _securityService: SecurityService,
    private _customFieldsService: CustomFieldsService,
    private _gridFields: GridFieldsService,
    public cdRef: ChangeDetectorRef,
    private _sharedService: SharedService,
    private _dataService: GDataService,
    private _stockItemsService: StockItemsService,
    private _facilityService: FacilityService,
    private _buildingService: BuildingService,
    private _floorService: FloorService,
    private _multiSitesService: MultiSiteService) {
    super();
    this._getPageState();

    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });

    this._layoutManager.applyOverly();
    this._currentUser = this._securityService.currentUser;

    this.loadLabels();
    this._getDeactivatedCustomFields();

    if (this._model && this._model.id) {
      this._locationsService.getNumberofstockPerDate(this._model.id).subscribe((x: any) => {
        this.NumberofstockPerDate = x;
      });

      this._locationsService.getNumberOfCatPerDate(this._model.id).subscribe((x: any) => {
        this.NumberOfCatPerDate = x;
      });

      this.LoadLocationChart();

      if (this._model?.address?.long && this._model?.address?.lat) {
        this.long = +this._model.address.long;
        this.lat = +this._model.address.lat;
      }
    }

    this.getAuth();
    //this.loadCustomFields(this._model?.id?.toString());


    this._gridFields.getGridFieldsByPage('locationTypes').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('locationTypes', data);
    });

    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('locationTypes', (gridColumns) => {
      this._locationsGridColumns = gridColumns;
    }));


    this._gridFields.getGridFieldsByPage('facility').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('facility', data);
    });


    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('facility', (fgridColumns) => {
      this._locationsFacilityColumns = fgridColumns;
    }));

    this._gridFields.getGridFieldsByPage('building').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('building', data);
    });

    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('building', (gridColumns) => {
      this._BuildingColumns = gridColumns;
    }));

    this._gridFields.getGridFieldsByPage('floor').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('floor', data);
    });

    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('floor', (gridColumns) => {
      this._FloorColumns = gridColumns;
    }));

    this._gridFields.getGridFieldsByPage('addresses').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('addresses', data);
    });
    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('addresses', (gridColumns) => {
      this._AddressesColumns = gridColumns;
    }));

    //#region Location Type Subscription
    this._locationTypesService.locationTypeAdded.subscribe((locationType: any) => {

      if (this._currentUser.isEnterprise) {
        if (locationType.accountIds && locationType.accountIds.length > 0) {
          var allSelectedAccountsExistInLocationType = true;
          this._selectedAccounts.forEach(element => {
            if (!locationType.accountIds.find((x: number) => x == element.accountId))
              allSelectedAccountsExistInLocationType = false;
          });
          if (allSelectedAccountsExistInLocationType) {
            if (!this._locationTypes.find(x => x.id == locationType.id)) {
              this._locationTypes.push(locationType);
              this._locationTypesFiltered = this._locationTypes;
              this._form.patchValue({
                locationType: locationType
              });
            }
          }

        }

      }
      else {
        if (!this._locationTypes.find(x => x.id == locationType.id)) {
          this._locationTypes.push(locationType);
          this._locationTypesFiltered = this._locationTypes;
        }
        this._form.patchValue({
          locationType: locationType
        });

      }

    })
    this._locationTypesService.locationTypeUpdated.subscribe((locationType: any) => {
      var UpdatedRecord = this._locationTypes.find(x => x.id == locationType.id);
      if (UpdatedRecord) {
        var Index = this._locationTypes.indexOf(UpdatedRecord);
        if (Index != -1) {
          this._locationTypes[Index] = locationType;
          this._addressesFiltered = this._locationTypes;



          this._form.patchValue({
            locationType: locationType
          });
        }
      }

    });
    //#endregion
    //#region address Subscription
    this._addressesService.AddressAdded.subscribe((address: any) => {

      if (this._currentUser.isEnterprise) {
        if (address.accountIds && address.accountIds.length > 0) {
          var allSelectedAccountsExistInAddress = true;
          this._selectedAccounts.forEach(element => {
            if (!address.accountIds.find((x: number) => x == element.accountId))
              allSelectedAccountsExistInAddress = false;
          });
          if (allSelectedAccountsExistInAddress) {
            if (!this._addresses.find(x => x.id == address.id)) {
              this._addresses.push(address);
              this._addressesFiltered = this._addresses;
              this._form.patchValue({
                address: address
              });
              this._form.get('addressdetails').setValue(this._fillAddressDetails(address));
            }
          }

        }

      }
      else {
        if (!this._addresses.find(x => x.id == address.id)) {
          this._addresses.push(address);
          this._addressesFiltered = this._addresses;
        }
        this._form.patchValue({
          address: address
        });
        this._form.get('addressdetails').setValue(this._fillAddressDetails(address));

      }

    })
    this._addressesService.AddressUpdated.subscribe((address: any) => {
      var UpdatedRecord = this._addresses.find(x => x.id == address.id);
      if (UpdatedRecord) {
        var Index = this._addresses.indexOf(UpdatedRecord);
        if (Index != -1) {
          this._addresses[Index] = address;
          this._addressesFiltered = this._addresses;



          this._form.patchValue({
            address: address
          });
          this._form.get('addressdetails').setValue(this._fillAddressDetails(address));

        }

      }

    });
    //#endregion

    //#region building Subscription
    this._buildingService.BuildingAdded.subscribe((building: any) => {


      if (!this.getlistofBuilding.find(x => x.id == building.id)) {
        if (!this._currentUser.isEnterprise) {
          if ((this._siteSelected && this._siteSelected.id == building.siteId)
            || !building.siteId
          ) {
            this.getlistofBuilding.push(building);
            this.bilidingFilter = this.getlistofBuilding;
            this._form.patchValue({
              building: building
            });
          }

        }
        else {
          this.getlistofBuilding.push(building);
          this.bilidingFilter = this.getlistofBuilding;
          this._form.patchValue({
            building: building
          });
        }

      }

    })
    this._buildingService.BuildingUpdated.subscribe((building: any) => {
      var UpdatedRecord = this.getlistofBuilding.find(x => x.id == building.id);
      if (UpdatedRecord) {
        var Index = this.getlistofBuilding.indexOf(UpdatedRecord);
        if (Index != -1) {
          this.getlistofBuilding[Index] = building;
          this.bilidingFilter = this.getlistofBuilding;
          this._form.patchValue({
            building: building
          });
        }

      }

    });
    //#endregion
    //#region floor Subscription
    this._floorService.FloorAdded.subscribe((floor: any) => {


      if (!this._getListOfFloor.find(x => x.id == floor.id)) {
        if (!this._currentUser.isEnterprise) {
          if ((this._siteSelected && this._siteSelected.id == floor.siteId)
            || !floor.siteId
          ) {
            this._getListOfFloor.push(floor);
            this._floorFiltered = this._getListOfFloor;
            this._form.patchValue({
              floor: floor
            });
          }

        }
        else {
          this._getListOfFloor.push(floor);
          this._floorFiltered = this._getListOfFloor;
          this._form.patchValue({
            floor: floor
          });
        }

      }

    })
    this._floorService.FloorUpdated.subscribe((floor: any) => {
      var UpdatedRecord = this._getListOfFloor.find(x => x.id == floor.id);
      if (UpdatedRecord) {
        var Index = this._getListOfFloor.indexOf(UpdatedRecord);
        if (Index != -1) {
          this._getListOfFloor[Index] = floor;
          this._floorFiltered = this._getListOfFloor;
          this._form.patchValue({
            floor: floor
          });
        }

      }

    });
    //#endregion

    //#region facility Subscription
    this._facilityService.FacilityAdded.subscribe((facility: any) => {


      if (!this._Facility.find(x => x.id == facility.id)) {

        this._Facility.push(facility);
        this._FacilityFiltered = this._Facility;
        this._form.patchValue({
          facility: facility
        });


      }

    })
    this._facilityService.FacilityUpdated.subscribe((facility: any) => {
      var UpdatedRecord = this._Facility.find(x => x.id == facility.id);
      if (UpdatedRecord) {
        var Index = this._Facility.indexOf(UpdatedRecord);
        if (Index != -1) {
          this._Facility[Index] = facility;
          this._FacilityFiltered = this._Facility;
          this._form.patchValue({
            facility: facility
          });
        }

      }

    });
    //#endregion
  }

  ngAfterViewInit() {
    // this.reloadlist = 'locations';
    //this.reloadlist = this.notemove.goreload;
    //this.reloadlist = this.notemove.reloadlist;
    //this.reloadlist = this.note._getvalue ;
  }

  _getLocationTypes = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    if (model != null && model.filter != null) {
      try {
        let dsdd = [model, { activeonly: true }];
      }
      catch (error) {
      }

      model.accountIds = this._selectedAccounts.map((x) => x.accountId);

      return this._locationTypesService.getLocationTypes(params, model);
    }
  }

  _getFacilityGridList = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    if (model != null && model.filter != null) {
      return this._facilityService.getfacilitydatagrid(params, model);
    }
  }

  _getbuildingGridList = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    if (model != null && model.filter != null) {
      params.screenSiteId = this._siteSelected ? this._siteSelected.id : 0;

      return this._buildingService.getBuildingdatagrid(params, model);
    }
  }

  _getFloorGridList = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    if (model != null && model.filter != null) {
      params.screenSiteId = this._siteSelected ? this._siteSelected.id : 0;
      return this._floorService.getBuildingdatagrid(params, model);
    }
  }
  _getAddressesGridList = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    if (model != null && model.filter != null) {

      model.accountIds = this._selectedAccounts.map((x) => x.accountId);
      return this._addressesService.getAddresses(params, model);
    }
  }


  //#openform
  _openForm(componentName: string, maindailog: string = null) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model: {}, pageState: PageState.ADD, reload: 'model', submodel: maindailog };
  }
  //LocationType
  _onLocationRowSelectionChanges(e: any[]) {
    this._selectedLocationTypes = [];
    e.forEach((item) => {
      this._selectedLocationTypes.push(item);
    });
  }
  _onFacilityRowSelectionChanges(e: any[]) {
    this._selectedFacilityTypes = [];
    e.forEach((item) => {
      this._selectedFacilityTypes.push(item);
    });
  }

  _onRowSelectionChanges(e: any[]) {
    this._selectedbuilding = [];
    e.forEach((item) => {
      this._selectedbuilding.push(item);
    });
  }

  _onFloorRowSelectionChanges(e: any[]) {
    this._selectedFloor = [];
    e.forEach((item) => {
      this._selectedFloor.push(item);
    });
  }

  _onaddressesRowSelectionChanges(e: any[]) {
    this._selectedaddresses = [];
    e.forEach((item) => {
      this._selectedaddresses.push(item);
    });
  }
  //
  _closeLocationsWindow(): void {
    this._showLocationsGrid = false;
  }

  _selectLocationsHandler(): void {
    this._showLocationsGrid = true;
  }

  //=======================FACILITY =======================
  _selectFacilityOpenCloseHandler(openclose: boolean): void {
    this._showFacilityGrid = openclose;
  }

  //==================================================================
  _FetchAllAddressdOpenCloseHandler(openclose: boolean): void {
    this._showAddressGrid = openclose;
  }

  _selectOpenCloseHandler(openclose: boolean, e: any): void {

    if (e === undefined) {
      this._showBuildingGrid = openclose;
      this._showFloorGrid = openclose;
      this._showAddressGrid = openclose;
      return;
    }

    if (e.currentTarget.id == 'buildinglist')
      this._showBuildingGrid = openclose;
    else if (e.currentTarget.id == 'floorlist')
      this._showFloorGrid = openclose;
  }

  _returnSelectedLocationsHandler(e: any[]): void {
    this._showLocationsGrid = false;
    this._selectedLocationTypes.forEach((item: LocationType) => {
      this._form.controls.locationType.setValue(item);

    });

    this.locationValueChange(e);
  }

  _returnSelectedFacilityHandler(e: any[]): void {
    this._showFacilityGrid = false;
    this._selectedFacilityTypes.forEach((item: Facility) => {
      this._form.controls.facility.setValue(item);
    });
    //e
  }
  //======================================= BUILDING FLOOR Handler=========================
  _returnSelectedHandler(e: any): void {
    //     let collection :Array<any> = [] ;
    //    collection.push(e);
    //   let dd = collection.find((x) => x.currentTarget).id;
    //  let all =  collection.filter(x => x.currentTarget.id);

    switch (e.currentTarget.id) {
      case 'buttselectreturnfloor':
        this._showFloorGrid = false;
        this._selectedFloor.forEach((item: Floor) => {
          this._form.controls.floor.setValue(item);
        });
        break;

      case 'buttselectreturnbuilding':
        this._showBuildingGrid = false;
        this._selectedbuilding.forEach((item: Building) => {
          this._form.controls.building.setValue(item);
        });
        break;

      case 'buttselectreturnaddresses':
        this._showAddressGrid = false;
        this._selectedaddresses.forEach((item: Address) => {
          this._form.controls.address.setValue(item);
        });
        break;


      default:
        break;
    }
    e = null;

  }
  //======================================================================

  locationValueChange(event: any) {
    if (event) {
      if (this._form.get('vendor') != null) {
        if (this._form.get('vendor').value) {
          setTimeout(() => {
            this.kendoComboVendors.toggle();
            this.kendoComboVendors.focus();
          });
        } else {
          setTimeout(() => {
            this.kendoComboItems.toggle();
            this.kendoComboItems.focus();
          });
        }
      }
    }
  }

  getAddresses = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._addressesService.getAddresses(params, model);
  }


  //   _loadItems() {
  //     const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? '';
  //     return this._stockItemsService.getStockItemsListingBySiteWithReceiveDetails(JSON.parse(loggedInAccountSites)[0].siteId,this.comboBoxpagingationParams)
  //         .subscribe((data:any) => {


  //         if (this.comboBoxpagingationParams.search == '') {
  //             if (!this.beginScroll) {
  //                  this._items = data.body;
  //                  this._itemsFiltered = data.body;
  //             }else{
  //                 this._items = [...this._itemsFiltered,...data.body];
  //                 this._itemsFiltered = [...this._itemsFiltered,...data.body];
  //             }
  //         } else {
  //             if (!this.beginScroll) {
  //             this._items = data.body;
  //              this._itemsFiltered = data.body;
  //             } else {
  //                 this._items = [...this._itemsFiltered,...data.body];
  //                 this._itemsFiltered = [...this._itemsFiltered,...data.body];
  //             }
  //         }
  // }

  //#region _getDeactivatedCustomFields
  _getDeactivatedCustomFields() {
    this._customFieldsService
      .getDeactivatedCustomFields('Stock', this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(
          (x) => x.formTab.page === this._page
        );
      });
  }

  //#endregion


  async LoadLocationChart() {
    setTimeout(() => {
      this._locationsService
        .GetStockItemByLocationChart(this._model.id)
        .pipe()
        .toPromise()
        .then(async (data: any) => {
          this.stockItemLocationChartDetail = data;
          this.stockItemLocationChart = this.stockItemLocationChartDetail.chart;
          this.stockItemLocationSecondChart =
            this.stockItemLocationChartDetail.secondChart;
        });
    }, 300);



    this._gridFields
      .getGridFieldsByPage('stockItems')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects(
          'stockItems',
          data
        );
        this._stockItemGridColumns = data;
      });
  }

  _getStockItemByLocation = (
    params?: any,
    model?: any
  ): Observable<DataWithPagingMetadata<any>> => {
    var startEndDate: any = {
      startDate: this.stockItemLocationChartDetail.startDate,
      endDate: this.stockItemLocationChartDetail.endDate,
      model: model
    };
    return this._stockItemsService.GetStockItemByLocationId(
      this._model.id,
      startEndDate,
      params,
    );
  }

  StockItemLocationChartOnActive(event: any) {
    if ((event.target as HTMLElement).tagName != 'DIV')
      this.openStockItemLocationForm = true;
  }

  StockItemLocationChartOnClose() {
    this.openStockItemLocationForm = false;
  }

  ExpandCollapseStockItemNumberGrid(isExpand: boolean) {
    this.isStockItemNumberGridExpanded = !isExpand;
  }

  ExpandCollapseStockItemNumberChart(isExpand: boolean) {
    this.isStockItemNumberChartExpanded = !isExpand;
  }

  _getPageState() {
    this._model =
      this._sharedService.model && this._sharedService.model.model
        ? this._sharedService.model.model
        : null;
    this._pageState =
      this._sharedService.model && this._sharedService.model.pageState
        ? this._sharedService.model.pageState
        : null;
    this._active = true;

    if (this._pageState === (PageState.ADD || PageState.COPY) && this._model && this._model.id > 0) {
      this.copyModelId = this._model.id;
      this._model.id = null;
      this._model.code = null;
    }
    if (this._model && this._model.site) {
      this._loadFormSites(true, this._model.site);
    }
    else {
      this._loadFormSites();
    }
  }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }

  _NOSTabClick() {
    this._NOSActive = true;
    this._NOCActive = false;
  }

  _NOCTabClick() {
    this._NOSActive = false;
    this._NOCActive = true;
  }
  //#region   _viewInactiveFields _NOSActive
  _viewInactiveFields() {
    this._customFieldsService
      .getDeactivatedCustomFields('stock', this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(
          (x) => x.formTab.page === this._page
        );
      });
    // this._deactivatedFieldsForm = true;
  }
  _closeInactiveFields() {
    this._deactivatedFieldsForm = false;
  }

  //#endregion

  _reactivate(item: any) {
    this.reactivateItem = item;
    this.reactivate = true;
    const sub = this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        this._customFieldsService
          .reactivateCustomField(this.reactivateItem.id, item)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  // this.loadCustomFields(this._model?.id?.toString());
                  this.getSystemFieldsAndCustomFields();
                  this._getDeactivatedCustomFields();
                  // this._deactivatedFieldsForm = false;
                } else {
                  return;
                }
              }
            }
            // this._deactivatedFieldsForm = false;
          });
        // this._deactivatedFieldsForm = false;
      } else {
        this.reactivate = false;
      }
      sub.unsubscribe();
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name,
    });
    // this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
    this._getDeactivatedCustomFields();
  }

  _onEditFields() {
    if (!this._currentUser.isEnterprise) {
      this._pageState = PageState.EDIT_FIELDS;
    } else {
      if (!this._selectedAccounts.length) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the desired account in the Accounts Tab',
          withoutConfirm: true
        });
      } else {
        this._pageState = PageState.EDIT_FIELDS;
        // this._editFormActive = true;
        // this._isCustomfieldsFormValue = true;
      }
    }
  }
  //#region  ngOnInit
  ngOnInit() {

    //this._loadLocationTypesList();
    this._loadLocationTypesListByAccount();
    this._loadFacility();
    this._viewInactiveFormTabs(true);
    // this._selectedAccount.valueChanges.subscribe((x) => {
    //   if (x) {
    //     this._accountsService
    //       .getSitesListByAccount(x.id)
    //       .subscribe((data: any) => {
    //         this._sites = data.filter(
    //           (x: { name: string }) => x.name != 'All Sites'
    //         );
    //         this._sitesFiltered = this._sites;
    //         if (this._pageState == PageState.ADD) {
    //           setTimeout(() => {
    //             this.KendoComboboxSite.toggle(true);
    //             this.KendoComboboxSite.focus();
    //           });
    //         }
    //       });
    //   }
    // });

    this._initForm();
    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    }
    else {
      this._kendoTabStripPosition = 'left';
    }

    // navigator.geolocation.getCurrentPosition((position) => {
    //   this.center = {
    //     lat: position.coords.latitude,
    //     lng: position.coords.longitude,
    //   };
    // });

    if (this._pageState == PageState.ADD) {
      // setTimeout(() => {
      //   this.kendoBarcodeGenLocationID.nativeElement.focus();
      // }, 500);
    }

    this._form.get('site').valueChanges.subscribe((x) => {
      if (x) {
        if (this._pageState == PageState.ADD) {
          // setTimeout(() => {
          //   this.kendoInputLocationDescription.nativeElement.focus();
          //   let LocationDesc = this.kendoInputLocationDescription;
          //   LocationDesc.nativeElement.classList.add('focusedInput');
          // });
        }
      }
    });

    this.getFormTabs();
    //this.getSystemFields();
    this.getSystemFieldsAndCustomFields();

    if (this._pageState == PageState.EDIT || this._pageState == PageState.VIEW) {
      this._selectedAccounts = (this._model?.locationSites ?? []).map((item: any) => ({
        siteId: item.site?.id ?? item.siteId,
        accountId: item.account?.id ?? item.accountId,
        site: item.site,
        account: item.account
      }));
      this._selectedAccountIds = this._selectedAccounts.map((a: any) => +a.accountId);
    }

    this._tabEnabled = this._selectedAccounts.length > 0;
    if (!this._currentUser.isEnterprise) {
      this._tabEnabled = true;
      this._loadAddressesByAccounts();
    }

    //this._loadLocationTypesListByAccount();
    if (this._currentUser.isEnterprise) {
      this._loadAddressesBuildingFloor();
      //this._loadLocationsDDByAccounts();
    }
  }

  _getAccounts = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._accountsService.getAccounts(params, model);
  };

  _getAccountIds() {
    if (this._currentUser.isEnterprise) {
      this._model.locationSites?.forEach((item) => {
        this._selectedAccountIds.push(item.account?.id);
      });
    }
    else {
      let accountSiteData = localStorage.getItem('loggedInAccountSites');
      if (accountSiteData) {
        let JsonData = JSON.parse(accountSiteData);
        JsonData.forEach((s: { siteId: number, accountId: number }) => {
          this._selectedAccountIds.push(s.accountId);
          this.siteId = s.siteId; //will be set like this for now
        })
      }
    }
  }


  zoomIn() {
    if (this.zoom < this.options.maxZoom) {
      this.zoom++;
    }
  }

  zoomOut() {
    if (this.zoom > this.options.minZoom) {
      this.zoom--;
    }
  }

  mapClicked(event: any /*google.maps.MouseEvent*/) {
  }

  addMarker() {
    this.markers.push({
      position: {
        lat: this.center.lat + ((Math.random() - 0.5) * 2) / 10,
        lng: this.center.lng + ((Math.random() - 0.5) * 2) / 10,
      },
      label: {
        color: 'red',
        text: 'Marker label ' + (this.markers.length + 1),
      },
      title: 'Marker title ' + (this.markers.length + 1),
      options: { animation: google.maps.Animation.BOUNCE },
    });
  }

  _setMandatoryTabs() {
    if (this.navTrigger) {
      let tabElementList = this.navTrigger.nativeElement.querySelector('ul');
      Array.from(tabElementList.children).forEach((child: any) => {
        if (child.firstChild.innerText == 'Location Info') {
          child.classList.add('mendatoryTab');
        }
      });
    }
  }
  //#endregion

  _addNewTab() {
    this._editFormActive = true;
    this._isAddTabFormValue = true;
    this._isRenameLabel = false;
    this._selectedLabelId = null;
  }
  _addNewField(tabId: number) {
    this._selectedTabId = null;
    this._selectedTabId = tabId;
    this._editFormActive = true;
    this._isCustomfieldsFormValue = true;
    this._isRenameLabel = false;
  }
  _openRenameForm(objectCode: string, isMandatory: boolean = false) {
    this._selectedLabelObjectCode = objectCode; //todo send system field label id
    //return; //open form once label id is set

    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
  }
  _openCustomRenameForm(customFieldId: number, tabId: number) {
    this._selectedLabelId = customFieldId;
    this._selectedTabId = tabId;
    this._editFormActive = !isNaN(customFieldId);
    this._isRenameFormValue = !isNaN(customFieldId);
    this._isRenameCustomFormValue = !isNaN(customFieldId);
    this._isRenameLabel = false;
    this._isMandatory = false;
  }
  _returnAdNew() {
    this._pageState = PageState.ADD;
    if (this._deactivatedFormTabsGridData?.length == 0) {
      this._viewInactiveFormTabs(true);
    }
  }
  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;

    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
    this.loadLabels();
    this.getFormTabs();
    this.getAuth();
  }

  _openCirclesForm() {
    this._showCirclesForm = true;
    this._tooltipVisibilityUpsert = false;
  }
  _closeCirclesForm() {
    this._showCirclesForm = false;
    this._tooltipVisibilityUpsert = true;
  }

  CheckIfWeAreInEditMode() {
    var isEditMode: boolean = false;

    if (this._pageState == PageState.EDIT) {
      isEditMode = true;
    }

    return isEditMode;
  }

  _skipLocationDescription() {
    if (this._pageState == PageState.ADD) {
      let LocationDesc = this.kendoInputLocationDescription;
      LocationDesc.nativeElement.classList.remove('focusedInput');
      this.KendoComboboxLocationType.toggle(true);
      this.KendoComboboxLocationType.focus();
    }
  }
  _removeTabActiveAndSkipAdd() {
    if (this._pageState == PageState.ADD) {
      let LocationDesc = this.kendoInputLocationDescription;
      LocationDesc.nativeElement.classList.add('focusedInput');
    }
  }
  _LocationDescSubmited() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        let LocationDesc = this.kendoInputLocationDescription;
        LocationDesc.nativeElement.classList.remove('focusedInput');
        LocationDesc.nativeElement.blur();
        this.KendoComboboxLocationType.toggle(true);
        this.KendoComboboxLocationType.focus();
      }, 100);
    }
  }
  _LocationDescFocusout() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        let LocationDesc = this.kendoInputLocationDescription;
        LocationDesc.nativeElement.classList.remove('focusedInput');
        LocationDesc.nativeElement.blur();
      }, 300);
    }
  }
  _barcodeSubmited() {
    this._locationsCode.setValue(this._form.get('code').value);
    if (this._pageState == PageState.ADD) {
      if (this._currentUser.isEnterprise) {
        setTimeout(() => {
          this.kendoComboboxAccount.toggle(true);
          this.kendoComboboxAccount.focus();
        }, 100);
      }
      if (!this._currentUser.isEnterprise) {
        setTimeout(() => {
          this.kendoInputLocationDescription.nativeElement.focus();
          let LocationDesc = this.kendoInputLocationDescription;
          LocationDesc.nativeElement.classList.add('focusedInput');
        });
      }
    }
  }
  _generateBarcodeClick() {
    this.runGenerateBarcode();
  }
  private runGenerateBarcode() {
    let counter = 1;
    this.generateBarcode(counter).subscribe((data: any) => {
      this._locationsCode.setValue(data.result.toString());
      this._form.patchValue({
        code: data.result.toString(),
      });
    });
    if (this._pageState == PageState.ADD) {
      if (this._currentUser.isEnterprise) {
        setTimeout(() => {
          this.kendoComboboxAccount.toggle(true);
          this.kendoComboboxAccount.focus();
        }, 100);
      }
      if (!this._currentUser.isEnterprise) {
        setTimeout(() => {
          this.kendoInputLocationDescription.nativeElement.focus();
          let locationDesc = this.kendoInputLocationDescription;
          locationDesc.nativeElement.classList.add('focusedInput');
        });
      }
    }
  }
  private generateBarcode(quantity: number) {
    return this._barcodeGeneratorsService.getBarcode('locations', quantity);
  }

  _locationTypesSelectionChanged(model: any): void {
    this._currentType = model ? model.code : null;

    if (this._currentType == 'Stationary') {
      if (!this._addresses) {
        this._loadAddressesBuildingFloor();
      }
    } else {
      if (!this._locations) {
        //this._loadLocationsDD();
        this._loadLocationsDDByAccounts();
      }
    }
  }





  _loadLocationTypesList() {

    return this._locationTypesService
      .getLocationTypeListing()
      .subscribe((data: any) => {
        this._locationTypes = data;
        this._locationTypesFiltered = data;
      });
  }
  _loadLocationTypesListByAccount() {
    let model = { accountIds: this._selectedAccounts.map((x) => x.accountId) };
    return this._locationTypesService
      .getLocationTypeListingByAccount(model)
      .subscribe((data: any) => {
        this._locationTypes = data;
        this._locationTypesFiltered = data;
        this.validateDropDowns();
      });
  }
  _loadFacility() {
    return this._facilityService
      .getFacilityListing()
      .subscribe((data: any) => {
        this._Facility = data;
        this._FacilityFiltered = data;
      });
  }

  _handleLocationTypesFilter(value: any) {
    this._locationTypesFiltered = this._locationTypes.filter(
      (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }
  _handFacilityFilter(value: any) {
    this._FacilityFiltered = this._Facility.filter(
      (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _loadAddressesBuildingFloor() {
    let model = {};
    if (this._currentUser.isEnterprise)
      model = {};
    else
      model = { id: this._siteSelected?.id };
    return this._addressesService
      .getAddressesSiteBuildingSummary(model)
      .subscribe((data: any) => {
        // this._addresses = data.addressSummaryDto;
        // this._addressesFiltered = data.addressSummaryDto;

        this.getlistofBuilding = data.buildingDto;
        this.bilidingFilter = data.buildingDto;

        this._getListOfFloor = data.floorDto;
        this._floorFiltered = data.floorDto;
        this.validateDropDowns();
      });
  }
  _loadAddressesByAccounts() {
    let model = { accountIds: this._selectedAccounts.map((x) => x.accountId) };
    return this._addressesService.getAddressesByAccounts(model)
      .subscribe((data) => {
        this._addresses = data;
        this._addressesFiltered = data;
        this.validateDropDowns();

      });
  }

  _handleAddressesFilter(value: any) {
    this._addressesFiltered = this._addresses.filter(
      (s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _handleBuilidingFilter(value: any) {
    this.bilidingFilter = this.getlistofBuilding.filter(
      (s) => s.description.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _loadLocationsDD() {

    return this._locationsService
      .getLocationListing()
      .subscribe((data: any) => {
        this._locations = data;
        this._locationsFiltered = data;
      });
  }
  _loadLocationsDDByAccounts() {
    if (this._currentUser.isEnterprise) {
      let model = { accountIds: this._selectedAccounts.map((x) => x.accountId) };
      return this._locationsService
        .getLocationsByAccounts(model)
        .subscribe((data: any) => {
          this._locations = data;
          this._locationsFiltered = data;
        });
    }
    else {
      const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? '';
      if (loggedInAccountSites != '') {
        let locationAccountIds = new Array();
        locationAccountIds.push((JSON.parse(loggedInAccountSites)[0].accountId));
        let model = { accountIds: this._selectedAccounts.map((x) => x.accountId), siteId: this._siteSelected?.id };
        return this._locationsService.getLocationsByAccounts(model)
          .subscribe((data: any) => {
            this._locations = data;
            this._locationsFiltered = data;
          });
      }
    }


  }

  _handleLocationsFilter(value: any) {
    this._locationsFiltered = this._locations.filter(
      (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _handleFloorFilter(value: any) {
    this._floorFiltered = this._getListOfFloor.filter(
      (s) => s.description.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _onStateChanges(e: any) {
    var element: any = this.kendoMainWindow;
    if (e === 'minimized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    } else if (e === 'maximized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    } else if (e === 'default') {
      element.el.nativeElement.classList.add('fullWidthFormForm');
    }
  }

  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this._innerWidth = window.innerWidth;
    if (this._innerWidth > 450) {
      this._hiddenWindow = 'hidden';
      this._maximized = 'maximized';
    } else {
      this._hiddenWindow = '';
      this._maximized = 'default';
    }
    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    } else {
      this._kendoTabStripPosition = 'left';
    }
  }

  _onTabSelect(e: any) {
    this._mobileMenuToggle();
  }

  _mobileMenuToggle() {
    let mobiletabstrip = this.navTrigger.nativeElement.querySelector('ul');
    mobiletabstrip.classList.toggle('visibletab');
  }

  _onSave(e: any) {
    this.submit(e);
  }

  _onCancel() {
    this._closeForm(this._popupSaveModel);
  }


  _closeDialog(event: any) {
    if (event?.response) {
      switch (event.component) {
        case 'locationTypes':
          //this._loadLocationTypesList();
          //this._loadLocationTypesListByAccount();
          // this._form.get('locationType').setValue(event.response);
          this._isDialiog = event.open;
          break;

        case 'facility':
          // this._loadFacility();
          // this._form.get('facility').setValue(event.response);
          this._isDialiog = event.open;
          break;

        case 'building':
          // this._loadAddressesBuildingFloor();
          // this._form.get('building').setValue(event.response);
          this._isDialiog = event.open;
          break;

        case 'addresses':
          // this._loadAddressesBuildingFloor();
          //this._loadAddressesByAccounts();
          //this._form.get('address').setValue(event.response);
          //this._form.get('addressdetails').setValue(this._fillAddressDetails(event.response));
          this._isDialiog = event.open;
          break;

        case 'floor':
          // this._loadAddressesBuildingFloor();
          // this._form.get('floor').setValue(event.response);
          this._isDialiog = event.open;
          break;

        default:
          break;
      }

    } else {
      this._isDialiog = event;
    }
  }


  submodel: any;
  _closeForm(locationid: any = null) {

    this.reloadlist = this._sharedService.model.reload;
    this.submodel = this._sharedService.model.submodel;
    var closeComponent = {
      component: 'locations',
      isClosed: true,
      response: this.reloadlist === undefined ? null : locationid
    };

    this._active = false;
    this._gridLayoutManagerService.setGridDataSubjects('locations');
    this._layoutManager.setFromChanged('locations');
    this.ngOnDestroy();
    this._locationsService.LocationFormClosed(this._form.get('code').value ?? '');

    this._sharedService.closeDialog.emit(closeComponent);
    if (this.submodel === null || this.submodel === '')
      this._sharedService.model = {};
    //Quraim
    closeComponent.response = locationid;
    this._dataService.push(closeComponent);
    this._sharedService.model = {};

  }

  _edit() {
    this._pageState = PageState.EDIT;
  }
  //#region ValidateEnterpriseAndMultiSiteDropDowns
  validateDropDowns() {
    if (this._form.controls['building'].value
      && this.getlistofBuilding && this.getlistofBuilding.length > 0
      && !this.getlistofBuilding.find(x => x.id == this._form.controls['building'].value.id)) {
      this._form.controls['building'].setValue(null);
    }
    if (this._form.controls['floor'].value
      && this._getListOfFloor && this._getListOfFloor.length > 0
      && !this._getListOfFloor.find(x => x.id == this._form.controls['floor'].value.id)) {
      this._form.controls['floor'].setValue(null);
    }
    if (this._form.controls['homeLocation'].value
      && this._locations && this._locations.length > 0
      && !this._locations.find(x => x.id == this._form.controls['homeLocation'].value.id)) {
      this._form.controls['homeLocation'].setValue(null);
    }
    if (this._form.controls['currentLocation'].value
      && this._locations && this._locations.length > 0
      && !this._locations.find(x => x.id == this._form.controls['currentLocation'].value.id)) {
      this._form.controls['currentLocation'].setValue(null);
    }
    if (this._form.controls['address'].value
      && this._addresses && this._addresses.length > 0
      && !this._addresses.find(x => x.id == this._form.controls['address'].value.id)) {
      this._form.controls['address'].setValue(null);
    }
    if (this._form.controls['locationType'].value
      && this._locationTypes && this._locationTypes.length > 0
      && !this._locationTypes.find(x => x.id == this._form.controls['locationType'].value.id)) {
      this._form.controls['locationType'].setValue(null);
    }
  }
  //#endregion
  //#region  _initForm
  private _initForm() {
    this._form = this._fb.group({
      code: [this._model ? this._model.code : null, Validators.required],
      description: [
        this._model ? this._model.description : null,
        this.getLabel('LBL_LocDescription')?.isRequired
          ? Validators.required
          : null,
      ],

      addressdetails: [],
      locationType: [
        this._model ? this._model.locationType : null,
        this.getLabel('LBL_LocType')?.isRequired ? Validators.required : null,
      ],

      facility: [
        this._model ? this._model.facility : null,
        this.getLabel('LBL_Facility')?.isRequired ? Validators.required : null,
      ],

      building: [
        this._model ? this._model.building : null,
        this.getLabel('LBL_Building')?.isRequired ? Validators.required : null,
      ],
      floor: [
        this._model ? this._model.floor : null,
        this.getLabel('LBL_Floor')?.isRequired ? Validators.required : null,
      ],
      address: [
        this._model ? this._model.address : null,
        this.getLabel('LBL_LocAddress')?.isRequired
          ? Validators.required
          : null,
      ],
      palletCode: [
        this._model ? this._model.entityPallet?.code : null,
        this.getLabel('LBL_LocPallet#')?.isRequired
          ? Validators.required
          : null,
      ],
      truckMake: [
        this._model ? this._model.entityTruck?.truckMake : null,
        this.getLabel('LBL_LocTruckMake')?.isRequired
          ? Validators.required
          : null,
      ],
      truckModel: [
        this._model ? this._model.entityTruck?.truckModel : null,
        this.getLabel('LBL_LocTruckModel')?.isRequired
          ? Validators.required
          : null,
      ],
      truckColor: [
        this._model ? this._model.entityTruck?.truckColor : null,
        this.getLabel('LBL_LocTruckColor')?.isRequired
          ? Validators.required
          : null,
      ],
      truckVin: [
        this._model ? this._model.entityTruck?.truckVin : null,
        this.getLabel('LBL_LocTruckVin')?.isRequired
          ? Validators.required
          : null,
      ],
      truckLicensePlate: [
        this._model ? this._model.entityTruck?.truckLicensePlate : null,
        this.getLabel('LBL_LocTruckLicensePlate')?.isRequired
          ? Validators.required
          : null,
      ],
      stationaryArea: [
        this._model ? this._model.entityStationary?.area : null,
        this.getLabel('LBL_LocArea')?.isRequired ? Validators.required : null,
      ],
      stationaryShelf: [
        this._model ? this._model.entityStationary?.shelf : null,
        this.getLabel('LBL_LocShelf')?.isRequired ? Validators.required : null,
      ],
      stationaryRoom: [
        this._model ? this._model.entityStationary?.room : null,
        this.getLabel('LBL_LocRoom')?.isRequired ? Validators.required : null,
      ],
      stationaryAisle: [
        this._model ? this._model.entityStationary?.aisle : null,
        this.getLabel('LBL_LocAisle')?.isRequired ? Validators.required : null,
      ],
      stationaryBin: [
        this._model ? this._model.entityStationary?.bin : null,
        this.getLabel('LBL_LocBin')?.isRequired ? Validators.required : null,
      ],
      homeLocation: new FormControl(),
      currentLocation: new FormControl(),
      site: [
        this._model ? this._model.site : null,
        this.getLabel('')?.isRequired ? Validators.required : null,
      ],
    });
    if (this._model.locationType != null)
      this._locationTypesSelectionChanged(this._model.locationType);

    if (
      this._pageState == PageState.EDIT || this._pageState == PageState.VIEW || this._pageState == PageState.COPY || (this._pageState == PageState.ADD && this._model)
    ) {
      if (this._model?.locationType?.code === 'Moving') {
        this._form
          .get('homeLocation')
          .setValue(this._model.entityTruck.homeLocation);
        this._form
          .get('currentLocation')
          .setValue(this._model.entityTruck.currentLocation);
      } else if (this._model?.locationType?.code === 'Pallet') {
        this._form
          .get('homeLocation')
          .setValue(this._model.entityPallet.homeLocation);
        this._form
          .get('currentLocation')
          .setValue(this._model.entityPallet.currentLocation);
      } else if (this._model?.locationType?.code === 'Stationary') {
        this._form.get('addressdetails')
          .setValue(this._fillAddressDetails(this._model.address));
      }

      this._selectedAccount.setValue(this._model.account);
      this._locationTypesSelectionChanged(this._model.locationType);
    }
  }
  //#endregion


  private submit = (e: string) => {
    var sitesSelected: boolean = true;
    if (this._currentUser.isEnterprise) {
      if (this._currentUser.isEnterprise && this._selectedAccounts.length === 0) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please select account(s) to continue.',
        });
        return false;
      }
      else {
        var tmpAccountSites = this._selectedAccounts.filter(
          (x: any) => x.siteId != -1
        );
        if (tmpAccountSites.length != this._selectedAccounts.length) {
          this._layoutComponent.openPopup({
            title: 'Validation',
            message: 'Please select the site(s) of the selected account(s) to continue.',
          });
          sitesSelected = false;
          return false;
        }
      }
    }

    if (!this._currentUser.isEnterprise && !this._siteSelected && this.isLoggedInAllSites) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please select site to continue.',
        withoutConfirm: true
      });

      return false;
    }

    if (this._form.invalid && this._customValidation.find((x: any) => !x.value)) {
      this._invalidForm = true;
      this._invalidSubmit = true;
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
    }
    else if (this._form.invalid) {
      this._invalidForm = true;
    }
    else if (this._customValidation.find((x: any) => !x.value)) {
      this._invalidForm = true;
      this._invalidSubmit = true;
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
    }
    else {
      // work with custom fields
      if (this._customFieldsValue) {
        // const entries = Object.entries(this._customFieldsValue);
        // for (const [index, [key, value]] of entries.entries()) {
        //   this._customFieldsDictionary[key] = `${value}`;
        // }
        this._customFieldsValue.forEach((elementy: any) => {
          this._customFieldsDictionary[elementy.Key] = elementy.Value;
        });
      }
      //

      this._invalidForm = false;
      this._invalidSubmit = false;
      const model = this._form.value;
      model['customFieldsValue'] = this._customFieldsDictionary;

      // model['locationSites'] = [];
      // var tmpAccountSites = this._selectedAccounts.filter(
      //   (x: any) => x.siteId != -1
      // );
      // tmpAccountSites.forEach((item) => {
      //   if (
      //     model['locationSites'].filter(
      //       (x: any) => x.siteId == item.siteId && x.accountId == item.accountId
      //     ).length == 0
      //   ) {
      //     model['locationSites'].push(item);
      //   }
      // });
      model['locationTypeId'] = model.locationType.id;
      model['facilityId'] = model.facility?.id == 0 ? null : model.facility?.id;
      // model['floorid'] = model.floor?.id == undefined ? null : model.floor?.id;
      //model['siteId'] = model.site?.id; //Old Save SiteId
      model["siteId"] = this._siteSelected?.id;
      model['accountIds'] = this._selectedAccountIds.map((c) => c),
        model['locationSites'] = this._selectedAccounts.map((c: any) => {
          return {
            siteId: c.siteId,
            accountId: c.accountId,
            site: c.site,
            account: c.account
          }
        }),

        //======================================== Moving =============================
        //if (this._currentType === 'Moving') {
        model['entityTruck'] = {
          truckmake: model.truckMake,
          truckmodel: model.truckModel,
          truckcolor: model.truckColor,
          truckvin: model.truckVin,
          trucklicenseplate: model.truckLicensePlate,
          homeLocationId: model.homeLocation?.id > 0 ? model.homeLocation?.id : null,
          currentLocationId: model.currentLocation?.id > 0 ? model.currentLocation?.id : null,
          id: this._pageState == PageState.EDIT && this._model.entityTruck?.id > 0 ? this._model.entityTruck?.id : 0
        };
      //}
      //===================================================================================
      //======================================== Pallet ===================================
      // (this._currentType === 'Pallet') {

      model['entityPallet'] = {
        code: model.palletCode,
        homeLocationId: model.homeLocation?.id > 0 ? model.homeLocation?.id : null,
        currentLocationId: model.currentLocation?.id > 0 ? model.currentLocation?.id : null,
        id: this._pageState == PageState.EDIT && this._model.entityPallet?.id > 0 ? this._model.entityPallet?.id : 0
      };
      //}
      //===================================================================================
      //if (this._currentType === 'Stationary') {

      model['addressId'] = model.address?.id > 0 ? model.address?.id : null;
      model['buildingId'] = model.building?.id > 0 ? model.building?.id : null
      model['floorid'] = model.floor?.id > 0 ? model.floor?.id : null;
      model['entityStationary'] = {
        addressId: model.address?.id > 0 ? model.address?.id : null,
        area: model.stationaryArea,
        shelf: model.stationaryShelf,
        room: model.stationaryRoom,
        aisle: model.stationaryAisle,
        bin: model.stationaryBin,
        id: this._pageState == PageState.EDIT && this._model.entityStationary?.id > 0 ? this._model.entityStationary?.id : 0
      };
      //}
      if (this._pageState == PageState.EDIT || this._pageState == PageState.VIEW) {

        this._locationsService
          .updateLocation(this._model.id, model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {

              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  model.id = response.responseId;
                  this._locationsService.locationUpdated.emit(model);
                  if (e === 'saveAndClose') {
                    this._closeForm(model);
                  } else if (e === 'saveAndCopy') {
                    this.copyModelId = this._model.id;

                    this._popupSaveModel = { ...model };
                    this._form.controls.code.setValue(null);
                    this._pageState = PageState.ADD;
                    this.loadCustomFields();
                  } else if (e === 'saveAndNew') {
                    this._popupSaveModel = { ...model };
                    this._initForm();
                    this.openUpsert(this._page, {}, PageState.ADD);
                  }
                  else if (e === 'save') {
                    this._popupSaveModel = { ...model };
                    this._model = response.savedData;
                    this._selectedAccounts = [];
                    this._model.locationSites.forEach((item) => {
                      this._selectedAccounts.push({
                        siteId: item.site?.id,
                        accountId: item.account?.id,
                        site: item.site,
                        account: item.account
                      });
                    });
                  }
                } else {
                  return;
                }
              }
            }
          });
      } else {
        this._locationsService
          .createLocation(model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {

              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  this.note.createNote(response.responseId);
                  model.id = response.responseId;
                  this._locationsService.locationAdded.emit(model);
                  if (e === 'saveAndClose') {
                    this._closeForm(model);
                  } else if (e === 'saveAndCopy') {
                    this._form.controls.code.setValue(null);
                  } else if (e === 'saveAndNew') {
                    this._popupSaveModel = { ...model };
                    this.openUpsert(this._page, {}, PageState.ADD);
                  }
                  else if (e === 'save') {

                    this._popupSaveModel = { ...model };
                    this._model = response.savedData;
                    this._model.id = response.responseId;
                    this._pageState = PageState.EDIT;
                    this._selectedAccounts = [];
                    this._model.locationSites.forEach((item) => {
                      this._selectedAccounts.push({
                        siteId: item.site?.id,
                        accountId: item.account?.id,
                        site: item.site,
                        account: item.account
                      });
                    });
                  }
                } else {
                  return;
                }
              }
            }

          });
      }
    }
  }

  //#region  loadCustomFields
  private loadCustomFields(entityId?: string) {
    this._getFormTabsByPage();
    this._getCustomFields(entityId);
  }

  /** _getCustomFields */
  _getCustomFields(entityId?: string) {
    entityId = this.copyModelId?.toString() ?? this._model?.id?.toString();
    this._customFieldsService
      .getCustomFields('stock', this._page, entityId)
      .subscribe((data) => {
        if (this._model != null && this._model.id != null || this.copyModelId != null) {
          let that = this;
          data.map(function (x) {
            x.entityId = that._model.id ?? that.copyModelId;
          });
        }
        var tabIds = data
          .map((item) => item?.formTabId)
          .filter((value, index, self) => self.indexOf(value) === index);

        const grouped = this.groupBy(
          data,
          (item: { formTabId: any }) => item.formTabId
        );
        let that = this;
        tabIds.forEach(function (formTabId) {
          that._customFields[formTabId] = grouped.get(formTabId);
        });
        if (this.copyModelId) {
          let CustomFieldsDataForCopy: any = {};
          grouped.forEach(element => {
            element.forEach((value: any) => {

              let _cutomfieldData = value.customFieldsData?.find((f: any) => f.entityId == entityId);
              CustomFieldsDataForCopy[value.name] = _cutomfieldData?.value ?? null;
              if (value.customFieldType.type.toLowerCase() == 'date' && CustomFieldsDataForCopy[value.name])
                CustomFieldsDataForCopy[value.name] = new Date(CustomFieldsDataForCopy[value.name]);
              if (value.customFieldType.type.toLowerCase() == 'numeric' && CustomFieldsDataForCopy[value.name])
                CustomFieldsDataForCopy[value.name] = parseFloat(CustomFieldsDataForCopy[value.name]);
            });
            this._customFieldsValueChanges(CustomFieldsDataForCopy, null);

          });
        }
        this._customFieldsService
          .getFormTabsByPage(this._page)

          .subscribe((data: any) => {
            //get custom tabs first
            this._customTabs = data.filter(
              (x: { isCustom: boolean }) => x.isCustom == true
            );
            this._setMandatoryTabs();
            this.setMandatoryFields();
          });
      });


  }
  /** _getFormTabsByPage */
  _getFormTabsByPage() {
    this._customFieldsService
      .getFormTabsByPage(this._page)
      .subscribe((data: any) => {
        //get custom tabs first
        this._customTabs = data.filter(
          (x: { isCustom: boolean }) => x.isCustom == true
        );

      });
  }
  //#endregion

  groupBy(list: any[], keyGetter: any) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  // _customFieldsValueChanges(customFieldsValue: any = [], tabId: number) {
  //   Object.keys(customFieldsValue).forEach(key => {
  //     if (customFieldsValue[key] == null || customFieldsValue[key] == 'null') {
  //       customFieldsValue[key] = '';
  //     }

  //     let dsdf = this._customFields[tabId].find(x => x.name == key);
  //     if (this._customFields[tabId].find(x => x.name == key).entityId == undefined) {//new mode, custom field data not added yet
  //       this._customFields[tabId].find(x => x.name == key).entityId = -1;
  //       this._customFields[tabId].find(x => x.name == key).customFieldsData.push({ id: -1, value: 'null', entityId: -1 ,customFieldId:-1});
  //     }
  //     var customFieldData = this._customFields[tabId].find(x => x.name == key).customFieldsData.find(x => x.entityId == this._customFields[tabId].find(x => x.name == key).entityId);
  //     if (customFieldData != undefined) {
  //       customFieldData.value = customFieldsValue[key];
  //     }
  //   });
  //   this._customFieldsValue = customFieldsValue;
  // }
  _customFieldsValueChanges(customFieldsValue: any, tabId: number) {

    Object.keys(customFieldsValue).forEach((key) => {
      let customObject = {
        Key: key,
        Value: customFieldsValue[key],
      };
      let item = null;
      this._customFieldsValue.forEach((elementz: any) => {
        if (elementz.Key == key) {
          item = elementz;
        }
      });
      if (item != null) {
        let index = this._customFieldsValue.indexOf(item);
        if (index != -1) {
          this._customFieldsValue.splice(index, 1);
        }
      }
      var requiredCustomerField = this._customValidation.find(
        (x: any) => x.name == key
      );
      if (requiredCustomerField) {
        let item2 = null;
        this._customValidation.forEach((element: any) => {
          if (element.name == key) {
            item2 = element;
          }
        });
        if (item2 != null) {
          let index2 = this._customValidation.indexOf(item2);
          if (index2 != -1) {
            //this._customValidation.splice(index2, 1);
            this._customValidation[index2].value = customObject.Value;
          }
          //this._customValidation.push({'name': customObject.Key, 'value': customObject.Value})
        }
      }
      this._additionalErrors = [];
      if (this._customValidation.find((x: any) => !x.value)) {
        this._additionalErrors.push("Additional Error");
        this._additionalErrors = [];
      }

      this._customFieldsValue.push(customObject);
    });
  }
  //#region  _removeCustomField
  _removeCustomField(customFieldId: number) {

    for (var i = 1; i <= this._customFields.length; i++) {
      if (this._customFields[i] != null) {
        if (
          this._customFields[i].findIndex((x) => x.id == customFieldId) != -1
        ) {
          this._customFields[i] = this._customFields[i].filter(
            (x) => x.id != customFieldId
          );
          this._getDeactivatedCustomFields();
          return;
        }
      }
    }

  }
  //#endregion
  _viewInactiveFormTabs(onLoad: boolean = false) {
    this._customFieldsService
      .getDeactivatedCustomForms(this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFormTabsGridData = data;
        //  if(!onLoad)
        //  this._deactivatedFormTabsForm = true;
      });
  }
  reactivateTab: boolean;
  _reactivateFormTab(item: any) {
    this.reactivateTab = true;
    const sub = this._sharedService.okCloseClicked.subscribe((boolData: boolean) => {
      this.reactivateTab = true;
      if (boolData && this.reactivateTab) {
        // if (boolData && this.reactivateTab && (this.lastTabIdReactivated.length == 0 || !this.lastTabIdReactivated.includes(item.id))) {
        this.reactivateTab = false;
        let model: any = {
          customFieldEntityId: 1,
          page: this._page,
          accountIds: this._selectedAccountIds,
        };
        this._customFieldsService
          .reactivateFormTab(item.id, model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              // if (this.lastTabIdDeactivated.includes(item.id)) {
              //   this.lastTabIdDeactivated = this.lastTabIdDeactivated.filter(id => id !== item.id);
              // }
              // this.lastTabIdReactivated.push(item.id);
              this._viewInactiveFormTabs(false)
              this._customFieldsService
                .getFormTabsByPage(this._page)

                .subscribe((data: any) => {
                  //get custom tabs first
                  this.getFormTabs();
                  this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
                });
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                } else {
                  return;
                }
              }
            }
          });
      } else {
        this.reactivateTab = false;
      }
      sub.unsubscribe();
    });


    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
  }
  _closeInactiveFormTabs() {
    this._deactivatedFormTabsForm = false;
  }
  // lastTabIdDeactivated:number[] = []
  // lastTabIdReactivated:number[] = []
  //#endregion
  deactivateTab: boolean
  _deactivateTab(tabId: number, page: string) {
    this.deactivateTab = true;
    const sub = this._sharedService.okCloseClicked.subscribe((boolData: boolean) => {
      if (boolData && this.deactivateTab) {
        // if (boolData && this.deactivateTab && (this.lastTabIdDeactivated.length == 0 || !this.lastTabIdDeactivated.includes(tabId))) {
        this.deactivateTab = false;
        let model: any = {
          customFieldEntityId: 1,
          page: this._page,
          accountIds: this._selectedAccountIds,
        };
        this._customFieldsService.deleteCustomTab(tabId, model).subscribe((response: any) => {
          // this.lastTabIdDeactivated.push(tabId);
          // if (this.lastTabIdReactivated.includes(tabId)) {
          //   this.lastTabIdReactivated = this.lastTabIdReactivated.filter(id => id !== tabId);
          // }

          if (response != null && response['message'] != null) {
            this._customFieldsService.getFormTabsByPage(this._page).subscribe((data: any) => {
              //get custom tabs first
              this.getFormTabs();
              this._customTabs = data.filter((x: { isCustom: boolean }) => x.isCustom == true);
            });

            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });

            if (response['close'] != null) {
              if (response['close'] == true) {
                // this._closeForm();
              }
              else {
                return;
              }
            }
          }
        });
      } else {
        this.deactivateTab = true;
      }
      sub.unsubscribe();
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Deactivate This Tab?',
    });

  }


  //#region  _deactivateTab
  // _deactivateTab(tabId: number, page: string) {

  //   let model: any = {
  //     customFieldEntityId: page == 'locations' ? 1 : 2,
  //     page: this._page,
  //     accountIds: this._selectedAccountIds,
  //   };
  //     .deleteCustomTab(tabId, model)
  //     
  //     .subscribe((response: any) => {
  //       if (response != null && response['message'] != null) {
  //           .getFormTabsByPage(this._page)
  //           
  //           .subscribe((data: any) => {
  //             //get custom tabs first
  //             this._customTabs = data.filter(
  //               (x: { isCustom: boolean }) => x.isCustom == true
  //             );
  //             //Quraim
  //             //this.loadCustomFields(this._model?.id?.toString());
  //             //this.loadLabels();
  //             this.getFormTabs();
  //             this.getAuth();
  //           });
  //         this._layoutComponent.openPopup({
  //           title: 'Alert',
  //           message: response['message'],
  //           withoutConfirm: true
  //         });
  //         if (response['close'] != null) {
  //           if (response['close'] == true) {
  //             // this._closeForm();
  //           } else {
  //             return;
  //           }
  //         }
  //       }
  //       //   this._closeForm();
  //     });
  // }
  //#endregion


  private loadLabels() {
    this._gridFields
      .getGridFieldTextLabelByPage(this._page, this._language)

      .subscribe((data: GridFieldTextSummary[]) => {
        this._gridFieldText = data;
        this._initForm();
      });
  }

  getLabel(objectCode: any) {
    if (this._gridFieldText) {
      if (
        this._gridFieldText.find(
          ({ gridFieldDefinition }) =>
            gridFieldDefinition?.objectCode === objectCode
        )
      )
        var result = this._gridFieldText.find(
          ({ gridFieldDefinition }) =>
            gridFieldDefinition?.objectCode === objectCode
        );
      else result = null;

      return result ? result : null;
    }
  }

  formStatus(isInvalid: boolean) {
    this._custominvalidForm = isInvalid;
  }

  _reorderingtabs() {
    this._orderingTabsForm = true;
  }
  _closeOrderingTabsForm() {
    this._orderingTabsForm = false;
    this._dataTabsSelected = this._userNewDataTabs;
  }

  _comboValueChange(e: any, i: number) {
    if (this._dataTabsSelected.find((x) => x.order == i + 1)) {
      this._userNewDataTabs.find(
        (x) => x === this._dataTabsSelected.find((x) => x.order == i + 1)
      ).order = this._dataTabsSelected.find((x) => x.name === e.name).order;
    }
    this._userNewDataTabs.find((obj) => obj.name == e.name).order = i + 1;
    this._dataTabsSelected = this._dataTabsSelected.filter((obj) => obj !== e);
  }

  _onSaveTabOrdering() {
    this._gridFields
      .updateFormTabsReorder(this._userNewDataTabs)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._closeOrderingTabsForm();
        this._setMandatoryTabs();
        this.setMandatoryFields();
      });
  }

  getFormTabs() {
    this._gridFields
      .getformTabsByPage(this._page)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._dataTabsSelected = x;
        this._userNewDataTabs = x;
        //this.sortProduct(p => p.order, "ASC");
      });
  }

  getSystemFields() {
    this._gridFields
      .getSystemFieldsByPage(this._page)

      .subscribe((x: any) => {
        this._systemFields = x;
        this._editedSystemFields = x;
      });
  }

  dataMove(newLocData: any, oldLocData: any) {
    const sysF: any[] = this._systemFields;
    const sysFClone: any[] = [];

    sysF.forEach((element: any) => {
      sysFClone.push(Object.assign({}, element));
    });

    this._systemFields.find((x) => x.id === oldLocData.id).formOrder =
      sysFClone.find((x) => x.id === newLocData.id).formOrder;
    this._systemFields.find((x) => x.id === newLocData.id).formOrder =
      sysFClone.find((x) => x.id === oldLocData.id).formOrder;

    this._editedSystemFields = this._systemFields;
  }

  dragEnd() {
    this._gridFields
      .updatedSystemFieldReorder(this._editedSystemFields)

      .subscribe((x: any) => {
        this._systemFields = x;
        this._editedSystemFields = x;
      });
  }

  getAuth() {
    // this._gridFields.getFileAuthorization(this._auth, this._currentUser.appRole.id)
    this._gridFields
      .getFieldsAuthorization(this._page, this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization[]) => {
        this._gridFieldAuth = x;
      });
  }

  getAuthByLabel(objectCode: any) {
    if (this._gridFieldAuth) {
      if (
        this._gridFieldAuth.find(
          ({ gridFieldDefinition }) =>
            gridFieldDefinition?.objectCode === objectCode
        )
      )
        var result = this._gridFieldAuth.find(
          ({ gridFieldDefinition }) =>
            gridFieldDefinition?.objectCode === objectCode
        );
      else result = null;

      return result ? result : new GridFieldAuthorization();
    }
  }

  _handleAddressesChange(value: any) {
    this.addressTextarea.nativeElement.value = this._fillAddressDetails(value);
    setTimeout(() => {
      this.kendoComboAddresses.toggle(false);
    });
  }

  _fillAddressDetails(value: any) {
    var addressDetails = '';
    if (value != null) {
      value = value.entityAddress == null ? value : value.entityAddress;
      if (value.addressLine1 != null && value.addressLine1 != '') {
        addressDetails += value.addressLine1;
      }
      if (value.addressLine2 != null && value.addressLine2 != '') {
        addressDetails += '\n' + value.addressLine2;
      }
      if (value.city != null && value.city != '') {
        addressDetails += '\n' + value.city;
      }
      if (value.state != null && value.state != '') {
        if (value.city != null && value.city != '') {
          addressDetails += ' ' + value.state;
        } else {
          addressDetails += '\n' + value.state;
        }
      }
      if (value.zip != null && value.zip != '') {
        if (value.state != null && value.state != '') {
          addressDetails += ' ' + value.zip;
        } else {
          addressDetails += '\n' + value.zip;
        }
      }
      if (value.country != null && value.country != '') {
        addressDetails += '\n' + value.country;
      }
    }
    return addressDetails;
  }
  getSystemFieldsAndCustomFields() {
    this._gridFields.getSystemFieldsByPage(this._page)

      .subscribe((x: any) => {
        this._systemFields = x;
        this._editedSystemFields = x;
        this.loadCustomFields(this._model?.id?.toString());
        //this.setMandatoryFields();
      });
  }
  //#region  setMandatoryFields
  requiredSystemTabs: any = [];
  setMandatoryFields() {
    this._requiredFieldNames = [];
    this._requiredFields = [];
    this.requiredSystemTabs = [];
    setTimeout(() => {
      for (let item of this._systemFields) {
        if (item.gridFieldText.isRequired) {
          this._requiredFields.push(item);
        }
      }

      for (let item2 of this._customFields) {
        if (item2) {
          for (let item3 of item2) {
            if (item3.isRequired) {
              this._requiredFields.push(item3);
            }
          }
        }
      }
      this._requiredFields.forEach(element => {
        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }
        else {
          if (element.formTabId) {
            let SystemFieldTab = this._dataTabs.find(x => x.id == element.formTabId);
            if (SystemFieldTab)
              this.requiredSystemTabs.push(SystemFieldTab);
          }
        }
      });
      if (this.navTrigger) {
        let tabElementList = this.navTrigger.nativeElement.querySelector('ul');
        Array.from(tabElementList.children).forEach((child: any) => {

          child.classList.remove('mendatoryTab');
        });
        Array.from(tabElementList.children).forEach((child: any) => {

          if (this._requiredFieldNames.find(x => x.name === child.firstChild.innerText && (x.page ? x.page == this._page : x.formtab.page == this._page))) {
            child.classList.add("mendatoryTab")
          }
          if (
            this.requiredSystemTabs.find(
              (x: any) =>
                x.name === child.firstChild.innerText
            )
          ) {
            child.classList.add('mendatoryTab');
          }
        });
      }
      this._requiredFields.forEach((element) => {
        if (element.customFieldType) {
          this._customRequiredFields.push(element);
          let thisvalue =
            element.customFieldsData.filter(
              (x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)
            ).length > 0
              ? element.customFieldsData.filter(
                (x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)
              )[0].value
              : '';
          this._customValidation.push({
            name: element.name,
            value: thisvalue,
            tabName: element.formTab?.name,
          });
        }
      });


    }, 500);

  }
  //#endregion
  _onEditForms() {
    this._isEditForms = true;
  }

  _onCloseEditForms(event: boolean) {
    this._isEditForms = event;
  }

  openUpsert(componentName: string, model: any, pageState: PageState) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model, pageState };
  }

  // _closeDialog(event: boolean) {
  //   this._isDialiog = event;
  // }

  getStockItemLeadsString(stockItemLeads: any) {
    let leads = '';
    let counter = 0;
    stockItemLeads.forEach((element: any) => {
      if (counter > 0) {
        leads += ', ';
      }
      leads += element.stockitemleadtime;
      counter++;
    });
    return leads;
  }

  getStockImage(stockItemFiles: any) {
    let files = '';
    let counter = 0;
    stockItemFiles.forEach((element: any) => {
      if (counter > 0) {
        files += ', ';
      }
      files += element.file.thumbnail;
      counter++;
    });
    return files;
  }

  getCategoryImage(categoryFiles: any) {
    let catfiles = '';
    let counter = 0;
    categoryFiles.forEach((element: any) => {
      if (counter > 0) {
        catfiles += ', ';
      }
      catfiles += element.file.thumbnail;
      counter++;
    });
    return catfiles;
  }

  getVendors(vendors: any) {
    let vendor = '';
    let counter = 0;
    vendors.forEach((element: any) => {
      if (counter > 0) {
        vendor += ', ';
      }
      vendor += element.vendorid;
      counter++;
    });

    return vendor;
  }

  getTimeUnitCode(vendors: any) {
    let vendor = '';
    let counter = 0;
    vendors.forEach((element: any) => {
      if (counter > 0) {
        vendor += ', ';
      }

      vendor += element.stockItemLeadid;
      counter++;
    });

    return vendor;
  }

  getTimeUnit(vendors: any) {
    let vendor = '';
    let counter = 0;

    vendors.forEach((element: any) => {
      if (counter > 0) {
        vendor += ', ';
      }

      vendor += element.stockitemleadinterval;
      counter++;
    });

    return vendor;
  }

  getSitesString(accountSites: any, isId: boolean) {
    let sites = '';
    let counter = 0;

    accountSites.forEach((element: any) => {
      if (counter > 0) {
        sites += ', ';
      }

      if (!isId) {
        if (element.site) {
          sites += element.site.name;
        }
        else {
          sites += 'All Sites';
        }
      }
      else {
        if (element.site) {
          sites += element.site.id;
        }
      }

      counter++;
    });

    return sites;
  }

  getAccountsString(accountSites: any) {
    let accounts = '';
    let counter = 0;
    accountSites.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }
      accounts += element.account.name;
      counter++;
    });

    return accounts;
  }

  ClickOnMap(e: any) {
  }

  markerClick(e: any) {
    this._form.controls.lat.setValue(e.latLng.lat());
    this._form.controls.long.setValue(e.latLng.lng());
  }

  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }

  _onAccountRowSelectionChanges(e: any[]) {
    super._onAccountRowSelectionChanges(e, () => {
      this._loadLocationTypesListByAccount();
      this._loadLocationsDDByAccounts();
      this._loadAddressesByAccounts();
    });
  }

  //#region Multi Site Functions
  _loadFormSites(IsEdit: boolean = false, SavedSite: any = null) {
    this._multiSitesService.getAllSites().subscribe((data: any) => {
      //var _allSitesObj: any = {};
      //_allSitesObj.code = 'All Sites';
      //_allSitesObj.name = 'All Sites';
      //_allSitesObj.id = null;

      //data.splice(0, 0, _allSitesObj);

      this._sites = data;
      this._sitesFiltered = data;

      this.initAllSitesDropDown(IsEdit, SavedSite);
    });
  }

  initAllSitesDropDown(isEdit: boolean = false, SavedSite: any = null) {
    super.initAllSitesDropDown(isEdit, SavedSite);
    this._loadAddressesBuildingFloor();
    this._loadLocationsDDByAccounts();
  }

  _handleSitesChange(event: any) {
    super._handleSitesChange(event);
    this._loadAddressesBuildingFloor();
    this._loadLocationsDDByAccounts();
  }
  //#endregion
}
